const openedPage = {
  volcanes: {
    customerForm: {
      validationError: {
        customerEmail: {
          emptyMessage: 'Please, insert your email',
          defaultMessage: 'Please, insert your email',
        },
      },
    },
  },
};

module.exports = openedPage;
